import PropTypes from "prop-types";
import React from "react";

import RolesHistChart from "./charts/roles_hist_chart";
import RolesOverTimeChart from "./charts/roles_over_time_chart";
import RolesDemandSection from "./roles_demand_section";
import RolesPieSection from "./roles_pie_section";

const RolesPage = () => (
  <>
    <RolesDemandSection />
    <RolesPieSection />
    <RolesOverTimeChart />
    <RolesHistChart />
  </>
);

RolesPage.propTypes = {
  filters: PropTypes.object
};

export default RolesPage;
